import { FormType } from '../../../form-types';
import { ZaludColdFluQuestionFieldAnswers } from './questions';

const coldFlu: FormType<ZaludColdFluQuestionFieldAnswers> = {
  name: 'Cold & Flu Intake',
  questions: [
    'zalud_coldFlu_redFlagSymptoms',
    'zalud_coldFlu_worseningOrProlonged',
    'zalud_coldFlu_symptomOnsetTiming',
    {
      key: 'zalud_coldFlu_fever',
      next: {
        switch: [
          {
            condition: { 'zalud_coldFlu_fever.mild_fever': true },
            key: 'zalud_coldFlu_feverDuration'
          },
          {
            condition: { 'zalud_coldFlu_fever.high_fever': true },
            key: 'zalud_coldFlu_feverDuration'
          }
        ],
        els: 'zalud_coldFlu_symptoms'
      }
    },
    'zalud_coldFlu_feverDuration',
    'zalud_coldFlu_symptoms',
    'zalud_coldFlu_additionalSymptoms',
    'zalud_coldFlu_symptomOnset',
    'zalud_coldFlu_chronicLungDisease',
    'zalud_coldFlu_covidFluTestResult',
    'zalud_coldFlu_closeContact',
    'zalud_coldFlu_additionalComments',
    {
      key: 'zalud_coldFlu_consent',
      next: {
        condition: { 'zalud_coldFlu_consent.proceed': true },
        key: 'zalud_coldFlu_complete',
        els: 'zalud_coldFlu_ineligible'
      }
    },
    'zalud_coldFlu_complete',
    'zalud_coldFlu_ineligible'
  ]
};

export default coldFlu;
